<template>

    <li v-if="uploadState === REQUEST_STATE.PENDING" class="bx_include_file">
        <button type="button" class="btn_download" :id="id">
            <span class="sp" :class="className"></span>
            <span class="file_name">{{fileName}}</span>
            <span class="byte">{{readableFileSize}}</span>
            <span class="progress2">
                <span class="bar" :style="{width: percentCss}"></span>
            </span>
        </button>
        <button type="button" class="btn_delete" v-on:click.prevent="deleteDocument">
            <span class="sp">{{$t('components_common_document_deleteFile')}}</span>
        </button>
    </li>

    <li v-else-if="uploadState === REQUEST_STATE.SUCCESS" class="bx_include_file">
        <button type="button" class="btn_download on" :id="id" v-on:click.prevent="downloadTempDocument">
            <span class="sp" :class="className"></span>
            <span class="file_name">{{fileName}}</span>
            <span class="byte">{{readableFileSize}}</span>
            <span class="progress2">
                <span class="bar" :style="{width: percentCss}"></span>
            </span>
        </button>
        <button type="button" class="btn_delete" v-on:click.prevent="deleteDocument">
            <span class="sp">{{$t('components_common_document_deleteFile')}}</span>
        </button>
    </li>

    <li v-else class="bx_include_file">
        <div class="error">
            <p class="dsc_error">
                <span class="txt_error">{{$t('components_common_document_uploadFailed')}}</span>
                <a href="#" class="btn_reload" v-on:click.prevent="retry">{{$t('components_common_document_retry')}}</a>
            </p>
            <button type="button" class="btn_delete" v-on:click.prevent="deleteDocument" :id="id">
                <span class="sp">{{$t('components_common_document_deleteFile')}}</span>
            </button>
        </div>
    </li>
</template>

<script>
    import {REQUEST_STATE} from '@iamteacherpc/consts/request.js';
    import {getExtensionClassName, getReadableSize} from '@iamteacherpc/utils/file.js';

    export default {
        name: 'Document',

        props: {
            id: {
                type: String,
            },
            uploadState: {
                type: String,
                required: true,
            },
            fileName: {
                type: String,
                required: true,
            },
            fileSize: {
                type: Number,
                required: true,
            },
            percent: {
                type: Number,
            },
            documentNo: {
                type: String,
            },
            tokenKey: {
                type: Number,
            },
        },

        computed: {
            REQUEST_STATE() {
                return REQUEST_STATE;
            },

            className() {
                return `ico_${getExtensionClassName(this.fileName)}`;
            },

            readableFileSize() {
                return getReadableSize(this.fileSize);
            },

            percentCss() {
                return `${this.percent}%`;
            }
        },

        methods: {
            downloadTempDocument() {
                const objectStorageNo = this.documentNo;
                const key = this.tokenKey;
                const action = `${process.env.VUE_APP_API_URL}external/documents/temporary/${objectStorageNo}/${key}/download`;
                this.$emit('downloadTempDocument', {action, method: 'GET'});
            },

            deleteDocument() {
                this.$emit('deleteDocument', {documentKey: this.id});
            },

            retry() {
                this.$emit('retry', {documentKey: this.id});
            },
        }
    }
</script>

<style scoped>

</style>
